import { useMemo } from 'react';

import { useLatest } from 'hooks/useLatest';

import type { ItemCallbacks } from '../types';

type Args = {
  resolveDataNodeId: (treeId: string) => string;
  onOpenDetails: (dataNodeId: string) => void;
  onRequestMove: (treeId: string) => void;
  onAddChild: (parentTreeId: string, parentDataNodeId: string) => void;
  onShowMore: (parentTreeId: string) => void;
};

export function useTreeNodeCallbacks(args: Args): ItemCallbacks {
  const latest = useLatest(args);

  return useMemo<ItemCallbacks>(
    () => ({
      onOpenDetails: (treeId: string) => latest.current.onOpenDetails(latest.current.resolveDataNodeId(treeId)),
      onAddChild: (treeId: string) => latest.current.onAddChild(treeId, latest.current.resolveDataNodeId(treeId)),
      onShowMore: (parentTreeId: string) => latest.current.onShowMore(parentTreeId),
      onRequestMove: (treeId: string) => latest.current.onRequestMove(treeId)
    }),
    [latest]
  );
}
